<template>
  <div
    class="dropdown-expanded"
  >
    <ul class="dropdown-expanded__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="dropdown-expanded__list__tag"
        :class="[
          {'dropdown-expanded__list__tag--open': cloneId === item.id}]"
      >
        <div
          class="dropdown-expanded__list__tag__header"
        >
          <div

            class="dropdown-expanded__list__tag__header__title"
            @click="openthis(item)"
          >
            <h3>{{ item.title }}</h3>
          </div>
          <div
            v-if="item.toggle"
            class="dropdown-expanded__list__tag__header__toggle"
            :class="[
              {'dropdown-expanded__list__tag__header__toggle--open': cloneId === item.id}]"
          >
            <toggle-view
              :is-disabled="cloneId !== item.id"
              @setResult="getToggleInfo"
            />
          </div>
          <div
            v-if="!item.link"
            class="dropdown-expanded__list__tag__header__icon"
            :class="[
              {'dropdown-expanded__list__tag__header__icon--rotate': cloneId === item.id}]"
            @click="openthis(item)"
          >
            <i
              class="icon-arrow"
            />
          </div>
        </div>

        <div
          v-if="item.text !== ''"
          class="dropdown-expanded__list__tag__text"
          :class="[
            {'dropdown-expanded__list__tag__text--open': cloneId === item.id}]"
        >
          <p>{{ item.text }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'DropdownExpanded',

  components: {
    ToggleView: () => import('@/components/toggle/toggle-view')
  },

  mixins: [variant],
  props: {

    items: {
      type: [Array, Object],
      required: true
    }
  },

  data() {
    return {
      cloneId: ''
    };
  },

  methods: {
    openthis(item) {
      if (!item.link) {
        if (this.cloneId === item.id) {
          this.cloneId = '';
        } else {
          this.cloneId = item.id;
        }
      } else {
        let routeData = this.$router.resolve({ name: 'privacy_policy' });
        window.open(routeData.href, '_blank');
      }
    },

    getToggleInfo(result) {
      this.$emit('toggleInfo', result);
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/dropdown/dropdown-expanded-view.scss"></style>



// WEBPACK FOOTER //
// dropdown-expanded-view.vue